export default __webpack_public_path__ + "static/media/image8.b91e993e.png";